import { observer } from "mobx-react-lite";
import React, { useEffect, useState } from "react";
import "../Certificacion/Curso.css";
import candado from "../../images/Closed.png";
import ubicacion from "../../images/Ubication.png";
import monedas from "../../images/Tax.png";
import correo from "../../images/Mail_.png";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import { Link, useHistory, useParams } from "react-router-dom";
import { useStore } from "../../app/stores/store";
import { Button, Modal } from "semantic-ui-react";
import LoginForm from "../../features/users/LoginForm";
import RegisterForm from "../../features/users/RegisterForm";
import CodigoInstitucional from "../Modals/CodigoInstitucional";
import LoadingComponent from "../../app/layout/LoadingComponent";
import { getCATCursoDetail } from "../../app/models/DetailCATCurso";
import agent from "../../app/api/agent";
import CursoEdicion from "./CursoEdicion";
import CursoEdiciones from "./CursoEdiciones";

interface Props {
  recarga: boolean;
}

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#258cc3",
    color: theme.palette.common.white,
    fontWeight: "bold",
    fontFamily: "Gotham",
    fontSize: 15,
  },
  body: {
    fontSize: 15,
    fontFamily: "Gotham",
    color: theme.palette.common.white,
  },
}))(TableCell);

let n: any;
var datesInicio: Date[] = [];
var datesFin: Date[] = [];
var idEdiciones: any[] = [];
var contador: number = 0;

const StyledTableRow = withStyles((theme) => ({
  root: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#53c0fa",
    },
    "&:nth-of-type(even)": {
      backgroundColor: "#258cc3",
    },
  },
}))(TableRow);

const useStyles = makeStyles({
  table: {
    maxWidth: "716px",
  },
});

export default observer(function Asesoria({ recarga }: Props) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [estadoData, setEstadoData] = useState(false);
  const [arancelCurso, setarancelCurso] = useState(0);
  const [edicionActual, setEdicionActual] = useState("");
  const history = useHistory();
  const {InscriptionsStore, CATCursosStore, SGPersonaStore, userStore: { isLoggedIn, user }, modalStore } = useStore();
  const {createInscription, update_SGPersonas } = InscriptionsStore;
  const {loadCATCursosById, getCATCursoRegistryDetail, getCATCursosRegistryAll, setEdicion } = CATCursosStore;
  const { id } = useParams<{ id: any }>();
  const { idUser } = useParams<{ idUser: string }>();

  useEffect(() => {
   
      loadCATCursosById(id).then(() => {
        CATCursosStore.getCATCursoByCodigo.map(
          async (item: getCATCursoDetail) => {
            if (item.edicion?.length === 1) {
              n = undefined;
              idEdiciones.splice(0, idEdiciones.length);
              item.edicion.map(async (item2) => {
                await agent.CATCursos.getArancel(item2.id).then((response) => {
                  if (response?.length >= 1) {
                    response.map((item3) => {
                      setarancelCurso(item3["arancel"]);
                    });
                  } else {
                    setarancelCurso(0);
                  }
                });
              });
              setEstadoData(true);
            } 
          }
        );
      });
    
  }, [loadCATCursosById]);
  if (CATCursosStore.loadingInitial)
    return <LoadingComponent content="Cargando datos.." />;

  if (estadoData) {
    return (
      <>
        <CursoEdicion cuota={arancelCurso} />
      </>
    );
  } else {
    return (
      <>
        <CursoEdicion cuota={arancelCurso} />
      </>
    );
  }
});
